import { z } from 'zod'

import { PiloteBackgroundCheckStatusZod } from '../common'
import { VolunteerZod } from '../volunteers'

import {
  JudicialRecordSoquijMunicipalSearchResultZod,
  JudicialRecordSoquijProvincialSearchResultZod,
} from './soquij-zod'

export const JudicialRecordZod = z.object({
  volunteer: VolunteerZod.omit({
    piloteId: true,
    centralId: true,
    regionId: true,
  }).extend({
    ids: z.array(
      z.object({
        id: z.string(),
        piloteId: z.number(),
        centralId: z.number(),
        regionId: z.string(),
      })
    ),
    code: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    birthDate: z.string(),
  }),
  decision: PiloteBackgroundCheckStatusZod.nullish(),
  lastDecisionDate: z.date().nullish(),

  requestedResults: z.number().optional().default(0),
  viewedResults: z.record(z.string(), z.date()).nullish().default({}),

  requestTimestamp: z.date(),
  expirationDate: z.date(),
  userId: z.string(),

  provincialSearchStatus: z.enum(['pending', 'processing', 'retrieving', 'completed', 'error']),
  provincial: z
    .object({
      numberOfResults: z.number(),
      values: JudicialRecordSoquijProvincialSearchResultZod.array(),
      timestamp: z.date(),
    })
    .optional(),

  municipalSearchStatus: z.enum(['pending', 'processing', 'retrieving', 'completed', 'error']),
  municipal: z
    .object({
      numberOfResults: z.number(),
      values: JudicialRecordSoquijMunicipalSearchResultZod.array(),
      timestamp: z.date(),
    })
    .optional(),

  soquijAutoAcceptedAt: z.date().nullish(),
})
